import React from 'react';
import './EventCollectionDetailHeader.css';
import '../shared/UserAvatar.css';
import Event from '../../models/Event';
import Collection from '../../models/Collection';
import {eventApi} from "../../api/EventApi";
import EventStats from "../../models/EventStats";
import {PulseLoader} from "react-spinners";
import {EventQuestionType} from "../../models/EventQuestionType";
import {ideaApi} from "../../api/IdeaApi";

export class CollectionSummary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stats: {},
            ideas: {}
        }
    }

    componentDidMount() {
        const {collection} = this.props;
        Collection.getEvents(collection).forEach(event => {
            this.fetchEventStats(event);
            this.fetchIdeas(event);
        });
    }

    fetchEventStats = event => {
        const eventId = Event.getId(event);
        eventApi.getStats(eventId)
            .then(result => {
                const {stats} = this.state;
                const newStats = {...stats};
                newStats[eventId] = result;
                this.setState({stats: newStats});
            })
    };

    fetchIdeas = event => {
        const eventId = Event.getId(event);
        ideaApi.getIdeas(eventId)
            .then(result => {
                const {ideas} = this.state;
                const newIdeas = {...ideas};
                newIdeas[eventId] = result;
                this.setState({ideas: newIdeas});
            })
    };

    render() {
        const {stats, ideas} = this.state;
        const {collection, onActiveEventChanged} = this.props;
        return (
            <div className="dashboard-report">
                <div className="report-card-wrapper col page-break-avoid p-0 m-0">
                    <div className="report-border">
                        <div className="report-card col py-3 px-4">
                            {Collection.getEvents(collection).map((event, index) => {
                                const eventId = Event.getId(event);
                                return (
                                    <EventSummaryRow
                                        key={eventId}
                                        stats={stats[eventId]}
                                        ideas={ideas[eventId]}
                                        event={event}
                                        index={index}
                                        onActiveEventChanged={onActiveEventChanged}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

class EventSummaryRow extends React.Component {

    onClick = $event => {
        $event.preventDefault();
        $event.stopPropagation();

        const {event, onActiveEventChanged} = this.props;
        onActiveEventChanged(event);
    };

    render() {
        const {index, event, stats, ideas} = this.props;
        return (
            <div className={`d-flex flex-row no-gutters px-0 py-2 my-1 ${index === 0 ? '' : 'border-top'}`}>
                <div className="col-7 text-wrap text-left d-flex flex-column">
                    <small className="clickable mt-1 font-weight-bolder">
                        Question {index + 1}
                    </small>
                    <div
                        style={{fontSize: '1.8rem'}}
                        className="font-weight-lighter clickable text-wrap text-truncate w-100 mw-100 mb-1">
                        {Event.getName(event)}
                    </div>
                </div>
                <div className="col-5 m-0 p-0 d-flex flex-row flex-nowrap">
                    <div className="col-4 text-center p-0 m-0">
                        <GoToEventButton onClick={this.onClick} event={event}/>
                    </div>
                    <div className="col-4 text-center p-0 m-0">
                        {(!stats || !ideas)
                            ? <Loading/>
                            : <ParticipatedSection event={event} stats={stats} ideas={ideas}/>
                        }
                    </div>
                    <div className="col-4 text-center p-0 m-0">
                        {(!stats || !ideas)
                            ? <Loading/>
                            : <AverageSection event={event} stats={stats} ideas={ideas}/>}
                    </div>
                </div>
            </div>
        )
    }

}

const Loading = () => {
    return <div className="d-flex flex-column w-100 h-100">
        <div className="m-auto">
            <PulseLoader size={10} color="#3D9AE2"/>
        </div>
    </div>
};


const GoToEventButton = props => {
    const {onClick} = props;
    return (
        <div className="d-flex flex-column w-100 h-100">
            <button
                className="px-3 py-2 rounded-pill btn pop-btn text-white m-auto"
                onClick={onClick}
            >
                <div className="d-flex flex-row no-gutters h-100 w-100">
                    <span className="my-auto">
                        View Report
                    </span>
                    <i className="material-icons my-auto">
                        keyboard_arrow_right
                    </i>
                </div>
            </button>
        </div>
    )
};

const Section = props => {
    const {title, count} = props;
    return (
        <div className="d-flex flex-column w-100 h-100">
            <h5 className="text-uppercase text-center w-100 mb-2 mt-auto">
                {title}
            </h5>
            <div className="text-teal text-center w-100 display-3 mb-auto">
                {count}
            </div>
        </div>
    )
};

const ParticipatedSection = props => {
    const {stats} = props;
    return (
        <Section
            title="Participated"
            count={EventStats.getUsersWhoContributedCount(stats)}
        />
    )
};

const AverageSection = props => {
    const {event, stats, ideas} = props;
    const questionType = Event.getQuestionType(event);
    if (EventQuestionType.isScaleType(questionType)) {
        return <ScaleSection event={event} stats={stats} ideas={ideas}/>
    } else {
        return null;
    }
    // } else if (EventQuestionType.isBinaryType(questionType)) {
    //     return <BinarySection event={event} stats={stats} ideas={ideas}/>
    // } else if (EventQuestionType.isMultipleType(questionType)) {
    //     return <MultipleSection event={event} stats={stats} ideas={ideas}/>
    // } else {
    //     return <DefaultSection event={event} stats={stats} ideas={ideas}/>
    // }
};

const ScaleSection = props => {
    const {stats} = props;
    return (
        <Section
            title="Average Rating"
            count={(
                <React.Fragment>
                    {EventStats.getSimpleScoreDisplay(stats) || 'N'}
                    /
                    {EventStats.getMaxScoreDisplay(stats) || 'A'}
                </React.Fragment>
            )}
        />
    );
};


// const BinarySection = props => {
//     return <ChoiceSection {...props}/>
// };
//
// const MultipleSection = props => {
//     return <ChoiceSection {...props}/>
// };
//
// const ChoiceSection = props => {
//     const {ideas} = props;
//
//     let idea = null;
//     for (const i of ideas) {
//         if (!idea) {
//             idea = i;
//         } else {
//             if (Ideas.getChoiceCount(i) > Ideas.getChoiceCount(idea)) {
//                 idea = i;
//             }
//         }
//     }
//
//     return (
//         <Section
//             title="Top Choice"
//             count={(
//                 <React.Fragment>
//                     {!!idea && Ideas.getContent(idea)}
//                 </React.Fragment>
//             )}
//         />
//     );
// };
//
//
// const DefaultSection = props => {
//     const {ideas} = props;
//
//     return (
//         <Section
//             title="Responses"
//             count={(
//                 <React.Fragment>
//                     {ideas.length}
//                 </React.Fragment>
//             )}
//         />
//     );
// };
